//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import IconView from "@/components/objects/IconView.vue";
import { BUILD_STORAGE_IMAGE_PATH, STORAGE_IMAGE_PATH } from "@/constants/ui.js";

export default {
  name: "CarouselFuturesCategories",
  components: { IconView },
  data() {
    return {
      isLoading: false,
      navTreeItems: [],
      navItems: [],
      currentCategory: null,
      swiper: null,
      initObserver: null,
      imagePath: [`${STORAGE_IMAGE_PATH}$id`, 'cover'],
    }
  },
  computed: {
    navTreeDetail() {
      var categories = null

      var responce =  this.$store.getters['categories/navTreeDetail'];

      if(responce){
        categories = []

        var respCat = responce.map(x => {
          const res = { ...x }
          delete res.items
          return res.node
        })

        categories = []

        var indexCat = null;

        for(indexCat in respCat){
          categories.push(respCat[indexCat])
          categories[indexCat].loading = false;
          if(categories.length >= 7){
            break;
          }
        }
      }

      return categories
    },
    mainObjects() {
      return this.$store.getters['objects/getMainObjects'];
    }
  },
  watch: {
    navTreeDetail(newVal) {
      this.navTreeItems = newVal || []
    },
    currentCategory(category) {
      if (!category || !category.id) {
        return
      }

      const params = {
        limit: 7,
        offset: 0,
        with_events: true,
        category: category.id,
        order: '-total_score',
      }

      this.$store.dispatch('objects/publicObjects', params).then(response => {
        this.navItems = response.items
        this.isLoading = false
      })
    },
  },
  async created() {
    const tree = this.$store.getters['categories/navTreeDetail']
    if (!tree || !tree.length) {
      await this.$store.dispatch('categories/getNavTreeDetail')
    }
    this.navTreeItems = this.navTreeDetail || []
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (!process.client) {
      return
    }

    this.observeInit()
  },
  beforeDestroy() {
    if (this.initObserver) {
      this.initObserver.disconnect()
      this.initObserver = null
    }
    if (this.swiper) {
      this.swiper.destroy()
      this.swiper = null
    }
  },
  methods: {
    observeInit() {
      if (this.swiper) {
        return
      }
      if (!('IntersectionObserver' in window) || !this.$el) {
        this.initSwiper()
        return
      }

      this.initObserver = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) {
          return
        }
        this.initObserver.disconnect()
        this.initObserver = null
        this.initSwiper()
      }, {
        rootMargin: '300px 0px',
      })

      this.initObserver.observe(this.$el)
    },
    ensureInitialCategory() {
      if (!this.navTreeItems || !this.navTreeItems.length) {
        return
      }
      if (this.currentCategory && this.currentCategory.id) {
        return
      }
      this.selectCategory(this.navTreeItems[0])
    },
    initSwiper() {
      const swiperEl = this.$refs.objectsSwiperContainer
      if (!swiperEl || this.swiper) {
        return
      }

      import('@/plugins/swiper.js')
        .then(({ Swiper, Navigation }) => {
          if (this.swiper) {
            return
          }
          this.swiper = new Swiper(swiperEl, {
            preventClicks: true,
            preventClicksPropagation: true,
            touchStartPreventDefault: true,
            slidesPerView: 'auto',
            spaceBetween: 15,
            init: true,
            navigation: {
              nextEl: '.objects-btn-next',
              prevEl: '.objects-btn-prev',
            },
            modules: [Navigation],
            observer: true,
            observeParents: true,
            on: {
              init: (swiper) => {
                this.ensureInitialCategory()
                swiper.updateAutoHeight(0)
              },
            },
            breakpoints: {
              640: {
                spaceBetween: 25,
              },
              960: {
                spaceBetween: 20,
              },
            },
          })
        })
    },
    selectCategory(category) {
      if (!category || !category.id) {
        return
      }

      const currentId = this.currentCategory && this.currentCategory.id
      if (currentId && currentId !== category.id) {
        this.isLoading = false
      }

      if (currentId !== category.id) {
        this.isLoading = true
        this.currentCategory = category
      }

      this.$nextTick(() => {
        if (this.swiper) {
          this.swiper.update()
          this.swiper.slideTo(0)
        }
      })
    },
    resolvedImagePath(item){
      if (!item.has_image) return ""

      if (this.useStorage) {
        return BUILD_STORAGE_IMAGE_PATH(item.image)
      } else {
        return `/public/object_images_files/first_image/${item.id}/?preview=1`
      }
    },
  }
}
